export default class ProductModel {
    qtd_emb
    quantidade
    estoque
    pro_observacao
    pro_descricao
    wrap
    category
}
